import { render, staticRenderFns } from "./m_summarized.vue?vue&type=template&id=9a1bc03c&scoped=true&"
import script from "./m_summarized.vue?vue&type=script&lang=js&"
export * from "./m_summarized.vue?vue&type=script&lang=js&"
import style0 from "./m_summarized.vue?vue&type=style&index=0&id=9a1bc03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1bc03c",
  null
  
)

export default component.exports